import React, { Component } from 'react';
import './emergencySetDeviceControl.less';
import PubSub from 'pubsub-js'
import { meshLog, SPRemove, SPGet, SPSet } from "../../../../../../utils/spUtils";
import { getDevicesByGroupId, getNameBygroupID, getBleVer } from '../../../../../../utils/meshUtils';
import { sendOpcode_group_light, sendOpcode_device_ota, sendOpcode_group_onoff } from '../../../../../../utils/opcodeUtils';
import btn_on from "../../../../../../imgs/mesh/btn_on.png";
import emergencySetDeviceControllogo from "../../../../../../imgs/logo/sensorDeviceControllogo.png";
import emergency from "../../../../../../imgs/item/emergency.png";
import btn_off from "../../../../../../imgs/mesh/btn_off.png";
import arrow_right from "../../../../../../imgs/btn/arrow_right.png";
import ota from "../../../../../../imgs/btn/ota.png";
import btn_on1 from "../../../../../../imgs/btn/btn_on.png";
import btn_off1 from "../../../../../../imgs/btn/btn_off.png";
import Manual_Test from "../../../../../../imgs/item/Manual_Test.png";
import { SET_ControlPageDetailPage_DIALOG_HIDE, SPIN_DIALOG_SHOW, SPIN_DIALOG_HIDE, } from "../../../../../../const/infoConst"
import { getDeviceNameByPid } from '../../../../../../utils/pidUtils';



export default class EmergencySetDeviceControl extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOn: true,
            dimLevel: 50,
            groupInfo: '',
            checked: false, //group是否展开
            devices: [], //group数据
            deviceName: "HSE",
            areaGroupDesc: "",
            devicePid: "pid",
            deviceMac: "mac",
            deviceVid: "vid",
            manufacture: "20409-09",

            monthlyTest: false,
            annualTest: false,
        }
    }



    componentDidMount() {
        this.updateGroupUI();
        PubSub.subscribe('updateGroupdataUI', (msg, data) => {
            this.updateGroupUI();
        })

        PubSub.subscribe("SET_ControlPageDetailPage_DIALOG_HIDE", (msg, index) => {
            meshLog("SET_ControlPageDetailPage_DIALOG_HIDE:", index);
            this.sendDataToParent()
        });
        this.sendDataToParent()

    }

    updateGroupUI() {
        meshLog('group渲染第一步', this.props);
        const groupInfo = JSON.parse(SPGet("groupInfo"))
        this.setState({
            groupInfo: groupInfo,
            dimLevel: groupInfo.dimLevel,
            isOn: groupInfo.isOnOff,
            // groupDevices: groupDevices,
            devices: getDevicesByGroupId(groupInfo.groupID), //group数据
        })
    }


    //原本的处理方法
    handleChange = (key, value) => {
        //边输入边赋值
        meshLog('value', value);
        meshLog('key', key);
        this.setState({ [key]: value });
        if (key == 'isOn') {
            const isOn = this.state.isOn
            this.setState({
                isOn: !isOn
            });
            sendOpcode_group_light(key, !isOn);
        } else {
            sendOpcode_group_light(key, value);
            this.setState({ [key]: value });
        }

    };

    handleChange1 = (key, value) => {
        //边输入边赋值
        meshLog('value', value);
        meshLog('key', key);
        this.setState({ [key]: value });
    };

    handleMouseUp = (key, value) => {
        //边输入边赋值 鼠标离开发指令，主要是针对调光调色
        meshLog('handleMouseUphandleMouseUp', value);
        sendOpcode_group_light(key, value);
    };

    sendDataToParent() {
        const controlDevice = JSON.parse(SPGet("controlDevice"))
        meshLog("controlDevice", controlDevice);
        if (controlDevice) {
            this.setState({
                deviceName: controlDevice.name,
                areaGroupDesc: SPGet("SelectMeshName") + ", " + getNameBygroupID(controlDevice.groupID),
                devicePid: getDeviceNameByPid(controlDevice.pid),
                deviceMac: controlDevice.macAddress,
                deviceVid: getBleVer(controlDevice.vid),
            });
        }

    };

    //ota
    otaClick = () => {
        sendOpcode_device_ota();
    };

    gotoSensorDevice = () => {
        PubSub.publish('gotoSensorDevice', '')//显示Sensror界面
    }

    monthlyTestClick(key) {
        let diff = this.state.monthlyTest;
        this.setState({
            monthlyTest: !diff,
        })
        //执行方法
        sendOpcode_group_light(key, diff);
    };

    annualTestClick(key) {
        let diff = this.state.annualTest;
        this.setState({
            annualTest: !diff,
        })
        //执行方法  sendOpcode_group_onoff(key);
    };

    onoffClick(key) {
        let diff = this.state.isOn;
        this.setState({
            isOn: !diff,
        })
        sendOpcode_group_onoff(key);

        PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
        setTimeout(() => {
            PubSub.publish(SPIN_DIALOG_HIDE, '');
        }, 2000)

    };



    render() {
        const { isOn, dimLevel, deviceName, areaGroupDesc, devicePid, deviceMac, deviceVid, manufacture, monthlyTest, annualTest, } = this.state;

        return (
            <div className="emergencySetDeviceControl-container">
                <div className="emergencySetDeviceControl-ui_grey_bg" />
                <div className="emergencySetDeviceControl-popup">
                    <div style={{ marginTop: "20px" }}>
                        <span style={{ marginLeft: "20px", fontSize: "18px" }}>Single Device Control</span>
                        {/* 灯数据 */}
                    </div>
                    <div className="emergencySetDeviceControl-line_space"></div>
                    {/* 组名和电源按钮 */}
                    <div className="emergencySetDeviceControl-group-header">
                        <div className="emergencySetDeviceControl-action-title">
                            <img src={emergency} />
                            <span>{deviceName}</span>
                        </div>
                    </div>

                    {/* Dim Level */}
                    {/* <div className="emergencySetDeviceControl-dim-level">
                        <div className="label">Dim level</div>
                        <div className="value-boxes">
                            <div className="box">{dimLevel}%</div>
                        </div>

                    </div> */}
                    {/* Dim滑动条 */}
                    {/* <div style={{ textAlign: "center", height: 60, display: 'flex' }}>
                        <input type="range"
                            min="0"
                            max="100"
                            value={dimLevel}
                            className="emergencySetDeviceControl-slider"
                            onMouseUp={(e) => this.handleMouseUp('dimLevel', parseInt(e.target.value))}
                            onChange={(e) => this.handleChange1('dimLevel', parseInt(e.target.value))} />
                        <img className="emergencySetDeviceControl-onoff-icon" src={isOn ? btn_on : btn_off} onClick={(e) => this.handleChange('isOn', parseInt(e.target.value))} />
                    </div> */}

                    <div className="emergencySetDeviceControl-group-header">
                        <div className="emergencySetDeviceControl-action-title">
                            {/* <img className='icon' src={emergency} /> */}
                            <span>Manual Test</span>
                        </div>
                        <img className="onoff-icon" src={isOn ? Manual_Test : Manual_Test} onClick={() => this.onoffClick('EmergencyTest')} />
                    </div>

                    <div className="emergencySetDeviceControl-group-header">
                        <div className="emergencySetDeviceControl-action-title">
                            {/* <img className='icon' src={emergency} /> */}
                            <span>Monthly Test</span>
                        </div>
                        <img className="onoff-icon" src={monthlyTest ? btn_on1 : btn_off1} onClick={() => this.monthlyTestClick('monthlyTest')} />

                    </div>

                    <div className="emergencySetDeviceControl-group-header">
                        <div className="emergencySetDeviceControl-action-title">
                            {/* <img className='icon' src={emergency} /> */}
                            <span>Annual Test</span>
                        </div>
                        <img className="onoff-icon" src={annualTest ? btn_on1 : btn_off1} onClick={() => this.annualTestClick('annualTest')} />
                    </div>

                    {/* 标题行 */}
                    <div className="emergencySetDeviceControl-controlPage_row">
                        <div className="emergencySetDeviceControl-controlPage_title">
                            <img className='emergencySetDeviceControl-icon' src={emergencySetDeviceControllogo} />
                            <span className='emergencySetDeviceControl-span'>Information</span>
                        </div>
                        {/* <span className='emergencySetDeviceControl-title_desc'>{areaGroupDesc}</span> */}
                    </div>


                    <div className="emergencySetDeviceControl-data-row">
                        <span className='item'>Device Type</span>
                        <span className='tips'>{devicePid}</span>
                    </div>
                    <div className="emergencySetDeviceControl-data-row">
                        <span className='item'>MAC Address</span>
                        <span className='tips'>{deviceMac}</span>
                    </div>
                    <div className="emergencySetDeviceControl-data-row">
                        <span className='item'>Firmware Version</span>
                        <span className='tips'>{deviceVid}</span>
                    </div>
                    <div className='emergencySetDeviceControl-ota'>
                        <div className="ota-info">
                            <span className='item'>OTA</span>
                            <img className='icon' onClick={() => { this.otaClick() }} src={ota} />
                        </div>
                        {/* <div className="ota-info">
                        <span>Date of Manufacture</span>
                        <span>202409-09</span>
                    </div> */}
                    </div>
                    <div className="emergencySetDeviceControl-data-row">
                        <span className='item'>Date of Manufacture</span>
                        <span className='tips'>{manufacture}</span>
                    </div>


                    <div className="emergencySetDeviceControl-info-row">
                        <div className="info-title">
                            <span className="info-span" >Self-checking Log</span>
                        </div>
                        <img className='arrow' src={arrow_right} />
                    </div>
                    {/* <div className="data-row2">
                    <span className='item2'>Date of Manufacture</span>
                    <span className='item2'>Date of Manufacture</span>
                    <span className='item2'>Date of Manufacture</span>
                </div> */}

                    <div className="emergencySetDeviceControl-info-row">
                        <div className="info-title">
                            <span className="info-span" >Emergency</span>
                        </div>
                        <img className='arrow' src={arrow_right} />
                    </div>
                    {/* <div className="data-row2">
                    <span className='item2'>Date of Manufacture</span>
                    <span className='item2'>Date of Manufacture</span>
                    <span className='item2'>Date of Manufacture</span>
                </div> */}




                    {/* 底部按钮 */}
                    <div className="control-footer">
                        <button className='cancelBtn' onClick={() => this.gotoSensorDevice()}>Cancel</button>
                        <button className='okBtn' onClick={() => this.gotoSensorDevice()} >Confirm</button>
                    </div>

                </div>

            </div>
        );
    }
}
